module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.animation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "my-dropdown-dd",
    style: (_vm.ddStyle)
  }, [_vm._t("dropdown")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48b23b53","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-my-dropdown/src/vue-my-dropdown.vue
// module id = 1519
// module chunks = 0